import React, { useState } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import FilterActiveDark from 'src/assets/images/FilterActiveDark.svg';
import FilterActiveLight from 'src/assets/images/FilterActiveLightNew.svg';
import FilterDark from 'src/assets/images/FilterDark.svg';
import FilterLight from 'src/assets/images/FilterLight.svg';
import {
    FilterIcon,
    FilterIconContainer,
} from './SetsFilter.styled';
import SetsFilterContainer from '.';
import {hasAppliedFilters} from 'src/utils/util';
import { setSetsSearchbarText } from 'src/pages/receiveSets/redux/actions/index.js';

const SetsFilter = ({
    isOpen = false,
    setIsOpen = () => {},
}) => {
    const bannerHeight = useSelector((state) => state.loginReducer.bannerHeight);
    const dispatch = useDispatch();

    const toggleFilter = () => setIsOpen((prev) => !prev);
    const closeFilter = () => {
        dispatch(setSetsSearchbarText({ filterType: 'districtFilters', searchText: '' }));
        setIsOpen(false);
    };
    const {appliedFilterNames} = useSelector(
        (state) => state.inventoryPreferenceReducer.setsFilterData || {},
        shallowEqual
    );

    return (
        <FilterIconContainer id="sets-filter-icon-container">
            <FilterIcon
                id="sets-filter-icon"
                deskPath={hasAppliedFilters(appliedFilterNames) ? FilterActiveLight : FilterLight}
                mobilePath={hasAppliedFilters(appliedFilterNames) ? FilterActiveDark : FilterDark}
                onClick={toggleFilter}
            />
            {isOpen && (
                <SetsFilterContainer
                    setIsOpen={setIsOpen}
                    onClose={closeFilter}
                    bannerHeight={bannerHeight}
                    isFilterApplied={hasAppliedFilters(appliedFilterNames)}
                />
            )}
        </FilterIconContainer>
    );
};

export default SetsFilter;
